import axiosInstance from 'Utils/axiosInstance';

export async function getSuggestions(filters = {}) {
    const params = new URLSearchParams(filters);
    const response = await axiosInstance.get('/suggestions', { params });

    if (!response?.data) return {};

    return response.data;
}

export async function getContactDuplicatedSuggestions() {
    const response = await axiosInstance.get('/suggestions/contact_duplicated_detected');

    if (!response?.data) return { count: 0, items: [] };

    return response.data;
}

export async function acceptSuggestion(suggestionId, params = {}) {
    try {
        await axiosInstance.post(`/suggestions/${suggestionId}/accept`, params);
    } catch (error) {
        // Ignore 409 Conflict - suggestion is no longer pending
        if (error.response?.status === 409) {
            return;
        }
        throw error;
    }
}

export async function rejectSuggestion(suggestionId) {
    await axiosInstance.post(`/suggestions/${suggestionId}/reject`);
}

export async function getSuggestionById(suggestionId) {
    const response = await axiosInstance.get(`/suggestions/${suggestionId}`);

    if (!response?.data) return null;

    return response.data;
}

export async function requestTaggingSuggestions(transactionIds) {
    const response = await axiosInstance.post('/suggestions', {
        type: 'transaction_taxonomy_tag_detected',
        items_ids: transactionIds,
    });

    if (!response?.data) return {};

    return response.data;
}

export async function requestReconciliation({ source = 'transaction', itemsIds }) {
    const response = await axiosInstance.post('/suggestions', {
        type: 'reconciliation',
        items_ids: itemsIds,
        source: source,
    });

    if (!response?.data) return {};

    return response.data;
}
